<template>
  <div class="_rfp_mctb_simple_01_ rfp-mctb-common-buynow-header">
    <div v-if="viewType === 'Carousel'" class="_rfp_mctb_simple_02_">
      <rfp-mctb-carousel-mode
        :retailer-unavailable="retailerUnavailable"
        :enable-rtl="enableRtl"
        :carousel-header-text="headerText"
        :store-locator-mode-options="retailerDetails"
        :component-diffs="componentDiffs"
        :productname="productname"
        :productids="productids"
      ></rfp-mctb-carousel-mode>
    </div>
    <div v-else class="_rfp_mctb_simple_02_">
      <rfp-mctb-list-mode
        :retailer-unavailable="retailerUnavailable"
        :component-diffs="componentDiffs"
        :carousel-header-text="headerText"
        :store-locator-mode-options="retailerDetails"
        :productname="productname"
        :productids="productids"
      ></rfp-mctb-list-mode>
    </div>
  </div>
</template>

<script>
import RfpMctbCarouselMode from '../rfp-mctb-carousel-mode/rfp-mctb-carousel-mode.vue';
import RfpMctbListMode from '../rfp-mctb-list-mode/rfp-mctb-list-mode.vue';

export default {
  name: 'rfp-mctb-simple-mode',
  components: {
    RfpMctbCarouselMode,
    RfpMctbListMode,
  },
  props: {
    retailerDetails: {
      type: Object,
      required: false,
    },
    headerText: {
      type: String,
      required: false,
    },
    viewType: {
      type: String,
      required: true,
    },
    enableRtl: {
      type: Boolean,
      required: true,
    },
    componentDiffs: {
      type: Boolean,
      required: true,
    },
    retailerUnavailable: {
      type: String,
      required: true,
    },
    productname: {
      type: String,
      required: true,
    },
    productids: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showWarningPopup: false,
    };
  },
  methods: {
    pageRedirectUrl(redirectURL, shouldOpenInNewWindow) {
      const target = shouldOpenInNewWindow === true ? '_blank' : '_self';
      window.open(redirectURL, target);
    },
  },
};
</script>
